module.exports = __webpack_public_path__ + "img/rank-2.3f19e0b9.svg";